import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../pages/home.vue';

Vue.use(VueRouter);

// 这里的路由如果希望通过浏览器地址输入框直接访问需要在服务端(/server/pages/page.controller.ts)文件中进行配置
const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/demo',
        name: 'demo',
        component: () => import(/* webpackChunkName: "demo" */ '@/pages/demo.vue'),
    },
    {
        path: '/schedule',
        name: 'schedule',
        component: () => import(/* webpackChunkName: "schedule" */ '@/pages/schedule.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/pages/common/login.vue'),
    },
    {
        path: '/active',
        name: 'active',
        component: () => import(/* webpackChunkName: "active" */ '@/pages/active/list.vue'),
    },
    {
        path: '/active/:id',
        name: 'active-id',
        component: () => import(/* webpackChunkName: "active-id" */ '@/pages/active/detail.vue'),
    },
    {
        path: '/information',
        name: 'informationList',
        component: () => import(/* webpackChunkName: "information" */ '@/pages/information/index.vue'),
    },
    {
        path: '/information/:id',
        name: 'information-detail',
        component: () => import(/* webpackChunkName: "information" */ '@/pages/information/information-detail.vue'),
    },
    {
        path: '/information/activity/:id',
        name: 'information-activity',
        component: () => import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail.vue'),
        children: [
            {
                path: '',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/index.vue'),
            },
            {
                path: 'content-1',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/content-1.vue'),
            },
            {
                path: 'content-2',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/content-2.vue'),
            },
            {
                path: 'content-3',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/content-3.vue'),
            },
            {
                path: 'content-4',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/content-4.vue'),
            },
            {
                path: 'content-5',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/content-5.vue'),
            },
            {
                path: 'discussion',
                component: () =>
                    import(/* webpackChunkName: "information" */ '@/pages/information/activity-detail/discussion.vue'),
            },
        ],
    },
    {
        path: '/users/:id',
        name: 'users',
        component: () => import(/* webpackChunkName: "demo" */ '@/pages/users/_id.vue'),
    },
    {
        path: '/users/:id/profile',
        name: 'users-profile',
        component: () => import(/* webpackChunkName: "demo" */ '@/pages/users/profile.vue'),
    },
    {
        path: '/users/:id/self-matchs',
        name: 'self-matchs',
        component: () => import(/* webpackChunkName: "demo" */ '@/pages/users/self-matchs.vue'),
    },
    {
        path: '/users/:id/certification',
        name: 'certification',
        component: () => import(/* webpackChunkName: "demo" */ '@/pages/users/certification.vue'),
    },
    {
        path: '/competitions',
        component: () => import(/* webpackChunkName: "competitions" */ '@/pages/competitions/index.vue'),
    },
    {
        path: '/competitions/:id',
        component: () => import(/* webpackChunkName: "competitions Detail" */ '@/pages/competitions/_id.vue'),
    },
    {
        path: '/competition-private/verify',
        component: () => import(/* webpackChunkName: "competitions Detail" */ '@/pages/competitions/verify.vue'),
    },
    {
        path: '/competition-join/:id',
        component: () => import(/* webpackChunkName: "competition signup Detail" */ '@/pages/competition-join/_id.vue'),
    },
    {
        path: '/competition-signup-agreement/:id',
        component: () =>
            import(/* webpackChunkName: "competition agreement Detail" */ '@/pages/competition-join/agreement.vue'),
    },
    {
        path: '/competitions/:id/:detail',
        component: () => import(/* webpackChunkName: "competitions Detail" */ '@/pages/competitions/_id.vue'),
    },
    {
        path: '/competition-submit/:id',
        name: 'competition-submit',
        component: () => import(/* webpackChunkName: "competitions Detail" */ '@/pages/competitions/submits.vue'),
    },
    {
        path: '/competition-guide-info/:id',
        component: () => import(/* webpackChunkName: "competitions Detail" */ '@/pages/competition-guide-info/_id.vue'),
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/pages/common/register.vue'),
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('@/pages/common/agreement.vue'),
    },
    {
        path: '/forget',
        name: 'forget',
        component: () => import('@/pages/common/forget.vue'),
    },
    {
        path: '/special',
        component: () => import('@/pages/special/index.vue'),
        name: 'special-index',
    },
    {
        path: '/special/:id',
        component: () => import('@/pages/special/_id.vue'),
        name: 'special',
    },
    {
        path: '/special/:id/:tab',
        redirect: '/special/:id',
    },
    {
        path: '/about/us',
        component: () => import('@/pages/about/about-us.vue'),
        name: 'about-us',
    },
    {
        path: '/activity/:id',
        component: () => import('@/pages/activity/index.vue'),
        name: 'activity',
    },
    {
        path: '/activity/:id/self-invite',
        component: () => import('@/pages/activity/self-invite.vue'),
        name: 'activity-self-invite',
    },
    {
        path: '/activity/:id/rank',
        component: () => import('@/pages/activity/rank.vue'),
        name: 'activity-rank',
    },
    {
        path: '/activity/:id/share-poster',
        component: () => import('@/pages/activity/share-poster.vue'),
        name: 'activity-share-poster',
    },
    {
        path: '/activity/:id/shipping-address',
        component: () => import('@/pages/activity/shipping-address.vue'),
        name: 'activity-shipping-address',
    },
    {
        path: '/guide/step-1',
        component: () => import('@/pages/guide/step-1.vue'),
        name: 'guide-step-1',
    },
    {
        path: '/guide/step-2',
        component: () => import('@/pages/guide/step-2.vue'),
        name: 'guide-step-2',
    },
    {
        path: '/guide/step-3',
        component: () => import('@/pages/guide/step-3.vue'),
        name: 'guide-step-3',
    },
    {
        path: '/guide/enterprise-step-1',
        component: () => import('@/pages/guide/enterprise-step-1.vue'),
        name: 'enterprise-step-1',
    },
    {
        path: '/guide/enterprise-step-2',
        component: () => import('@/pages/guide/enterprise-step-2.vue'),
        name: 'enterprise-step-2',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
    return (VueRouterPush.call(this, to) as any).catch(err => err);
};

export default router;
